module.exports = __webpack_public_path__ + "img/ic-alloynx.d7ad9824.png";